import hero from './illustration-hero.svg';
import micon from './icon-music.svg';
import './App.scss';

function App() {  
  return (
    <>
      <section className='order-scard'>
        
        <section className='order-scard-img'>
          <img src={ hero } alt=''/>
        </section>

        <section className='order-scard-info'>
          <h1>Order Summary</h1>
          <p>You can now listen to millions of songs, audiobooks, and podcasts on any device anywhere you like!</p>
          
          <nav className='order-scard-plan'>
            <img src={micon} alt='' />
            <section className='plan'>
              <h2>Annual Plan</h2>
              <span> $59.99/year</span>
            </section>
            <a href='/'>Change</a>
          </nav>

          <button>Proceed to Payment</button>
          <a href='/'>Cancel Order</a>
        </section>
      </section>
    </>
  );
}

export default App;